import './index.scss';
import IsometricMapHooks from "./inc/IsometricMapHooks";

jQuery(document).ready(($) => {
  new IsometricMapHooks($);
});
